"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pulseResponse = pulseResponse;
exports.stepResponse = stepResponse;
exports.stepResponseOvershoot = stepResponseOvershoot;
exports.stepResponseRiseTime = stepResponseRiseTime;
var Common = _interopRequireWildcard(require("./common"));
var GraphCalculations = _interopRequireWildcard(require("./graphs"));
var AdiMath = _interopRequireWildcard(require("./math"));
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function pulseResponse(inputValues, opAmpDB, stagesObject) {
  //Our pulse width will be 3/4 of the total time axis, so we can see the falling edge
  var pulsePercent = 1 / 2;
  var bwForCalculatingTime = inputValues.speed * pulsePercent;
  var timeAxis = createTimeAxis(bwForCalculatingTime);
  //var userPulseWidth = Common.calculateMinPulseWidthSpeed(inputValues.speed);
  var timeLength = timeAxis.length;
  var pulseWidthIndex = timeLength * pulsePercent;
  var stepResponseReturn = this.stepResponse(inputValues, opAmpDB, stagesObject, timeAxis);
  var stepResponseArray = stepResponseReturn[1];
  var riseTime = this.stepResponseRiseTime(stepResponseArray, timeAxis, inputValues);
  var overshoot = this.stepResponseOvershoot(stepResponseArray, timeAxis, inputValues);

  //Add the original step response by a negated version shifted in time by the pulse width
  var pulseResponseArray = [];
  for (var i = 0; i < stepResponseArray.length; i++) {
    if (i < pulseWidthIndex) {
      pulseResponseArray[i] = stepResponseArray[i];
    } else {
      pulseResponseArray[i] = stepResponseArray[i] - stepResponseArray[i - pulseWidthIndex];
    }
  }

  // Assume step response is settled by end is so is a good gain indicator.  This is more accurate way to calculate gain than using peak voltage / peackCurrent because it will incorporate the nonideal resistors.
  // However this method won't be accurate if step hasn't settled by the end of the step time.
  // The more accurate way would be to calculate gain using the stage 1 and stage 2 gains, but that's a lot of formula and ifs to account for the various stage options.  I was hoping we had a function for our 
  // total DC gain, but I couldn't find it.
  // Calling this good enough.
  let tiaGain = stepResponseArray[stepResponseArray.length - 1] / inputValues.peakCurrent;
  let offsetFromShuntResistance = inputValues.reverseVoltage / inputValues.shuntResistance * tiaGain;
  //Offset always is same sign as the photodiode current, so invert the offset if the pulse response goes down instead of up
  //if (tiaGain > 0) {
  pulseResponseArray = pulseResponseArray.map(pulseResponseValue => pulseResponseValue + offsetFromShuntResistance);
  // }
  //else {
  //    pulseResponseArray = pulseResponseArray.map(pulseResponseValue => pulseResponseValue - offsetFromShuntResistance);
  //}

  return [timeAxis, pulseResponseArray, riseTime, overshoot];
}
function stepResponse(inputValues, opAmpDB, stagesObject, timeAxis) {
  "use strict";

  var stepResponseArray = [],
    tempArray = [],
    fakeStages,
    impulseRes;
  fakeStages = createStagesforStepResponse(inputValues, opAmpDB, stagesObject);
  if (timeAxis === undefined) {
    var roughBW = GraphCalculations.getRoughBW(stagesObject);
    timeAxis = createTimeAxis(roughBW / 2);
  }

  //Increase our sample rate by 5x so that we have more internal accuracy, especially with slew rate limiting
  //slewRateEffect_TIA has to do some time shifting.  It also has to indentify when we switch from slew rate limited to not slew rate limited.
  //Both are much more accurate if we have more points to look at.
  //Method below robust even if we do not have equal timeAxis spacing
  let timeAxis5x = [];
  for (let i = 0; i < timeAxis.length - 1; i++) {
    let timeAxisDifference = timeAxis[i + 1] - timeAxis[i];
    timeAxis5x.push(timeAxis[i]);
    timeAxis5x.push(timeAxis[i] + timeAxisDifference * 0.2);
    timeAxis5x.push(timeAxis[i] + timeAxisDifference * 0.4);
    timeAxis5x.push(timeAxis[i] + timeAxisDifference * 0.6);
    timeAxis5x.push(timeAxis[i] + timeAxisDifference * 0.8);
  }

  // Step Response of 1 stage setup
  var stepResSetup1 = stepResponseSetup(fakeStages[0]);
  // Step Response of 1 point 
  for (var t = 0; t < timeAxis5x.length; t++) {
    stepResponseArray[t] = stepResponseIdeal(timeAxis5x[t], stepResSetup1, fakeStages[0]);
  }

  //add in slew rate effect of first op amp
  stepResponseArray = slewRateEffect_TIA(timeAxis5x, stepResponseArray, fakeStages[0].slewRate);

  // rest of the stages
  for (let i = 1, len = fakeStages.length; i < len; i++) {
    impulseRes = impulseResponse(timeAxis5x, fakeStages[i]);
    tempArray = AdiMath.convolve(stepResponseArray, impulseRes);
    stepResponseArray = tempArray;
  }

  //add in slew rate effect of 2nd op amp
  if (inputValues.stages === _photodiodeConstants.default.pdStages.twoStage) {
    stepResponseArray = slewRateEffect_2ndStage(timeAxis5x, stepResponseArray, 1e6 * stagesObject.stage2.opAmp.slewRate);
  }

  // if (user has selected a one stage design) && (photodiode polarity is positive)
  // polarity should be negative
  if (inputValues.stages == _photodiodeConstants.default.pdStages.oneStage && inputValues.biasPreference == _photodiodeConstants.default.biasPreferenceOptions.positive) {
    for (let k = 0, len = stepResponseArray.length; k < len; k++) {
      stepResponseArray[k] = stepResponseArray[k] * -1;
    }
  }

  //Now decimate back down to our original axis
  let decimatedStepResponseArray = [];
  for (let i = 0; i < stepResponseArray.length; i = i + 5) {
    decimatedStepResponseArray.push(stepResponseArray[i]);
  }
  //If we're missing a value, tack on the last value in the array
  if (decimatedStepResponseArray.length < timeAxis.length) {
    decimatedStepResponseArray.push(stepResponseArray[stepResponseArray.length - 1]);
  }
  return [timeAxis, decimatedStepResponseArray];
}

//Calculates 10% to 90% rise time
//This function always assumes the step response starts at 0, and is trying to go to the peak voltage.
//It is able to handle the case where the step response is inverted.
function stepResponseRiseTime(stepResponseArray, timeArray, inputValues) {
  //create local copy of array so we don't mess up original
  var stepResponseArrayLocal = stepResponseArray.slice(0);

  //first check if step response is the special case where it goes from 0 to a negative number.  If so, invert so we can do
  //the calculations like all the othe cases.
  if (inputValues.stages === _photodiodeConstants.default.pdStages.oneStage && inputValues.biasPreference == _photodiodeConstants.default.biasPreferenceOptions.positive) {
    for (var k = 0, len = stepResponseArrayLocal.length; k < len; k++) {
      stepResponseArrayLocal[k] = stepResponseArray[k] * -1;
    }
  }
  var timeInterval, voltageInterval, riseTime;
  var minValue = 0;
  var maxValue = stepResponseArrayLocal[stepResponseArrayLocal.length - 1];
  var amplitude = maxValue - minValue;
  var tenPercent = 0.1 * amplitude + minValue;
  var ninetyPercent = 0.9 * amplitude + minValue;
  var tenPercentFound = false;
  var ninetyPercentFound = false;
  for (var i = 1; i < stepResponseArrayLocal.length; i++) {
    if (!tenPercentFound && stepResponseArrayLocal[i] > tenPercent) {
      tenPercentFound = true;
      timeInterval = timeArray[i] - timeArray[i - 1];
      voltageInterval = stepResponseArrayLocal[i] - stepResponseArrayLocal[i - 1];
      var interpolatedTenPercentTime = timeArray[i - 1] + timeInterval * (tenPercent - stepResponseArrayLocal[i - 1]) / voltageInterval;
    }
    if (!ninetyPercentFound && stepResponseArrayLocal[i] > ninetyPercent) {
      ninetyPercentFound = true;
      timeInterval = timeArray[i] - timeArray[i - 1];
      voltageInterval = stepResponseArrayLocal[i] - stepResponseArrayLocal[i - 1];
      var interpolatedNinetyPercentTime = timeArray[i - 1] + timeInterval * (ninetyPercent - stepResponseArrayLocal[i - 1]) / voltageInterval;
      break;
    }
  }
  if (tenPercentFound && ninetyPercentFound) {
    riseTime = interpolatedNinetyPercentTime - interpolatedTenPercentTime;
  } else {
    riseTime = NaN;
  }
  return riseTime;
}

//Calculates the peak overshoot
//This function always assumes the step response starts at 0, and is trying to go to the peak voltage.
//It is able to handle the case where the step response is inverted.
function stepResponseOvershoot(stepResponseArray, timeArray, inputValues) {
  //create local copy of array so we don't mess up original
  var stepResponseArrayLocal = stepResponseArray.slice(0);

  //first check if step response is the special case where it goes from 0 to a negative number.  If so, invert so we can do
  //the calculations like all the othe cases.
  if (inputValues.stages === _photodiodeConstants.default.pdStages.oneStage && inputValues.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.positive) {
    for (var k = 0, len = stepResponseArrayLocal.length; k < len; k++) {
      stepResponseArrayLocal[k] = stepResponseArray[k] * -1;
    }
  }
  var largestValue = Math.max.apply(Math, stepResponseArrayLocal);
  var lastValue = stepResponseArrayLocal[stepResponseArrayLocal.length - 1];
  var percentOvershoot = (largestValue / lastValue - 1) * 100;
  return percentOvershoot;
}

//PRIVATE FUNCTIONS
//this function adds in the effect of slew rate for the second stage.   It simply clips the waveform to keep it at the appropriate slew.
function slewRateEffect_2ndStage(timeAxis, stepValues, slewRate) {
  "use strict";

  var slope, absSlope, newVal, sign;
  var timeLen = timeAxis.length;
  var timeStep = timeAxis[1] - timeAxis[0];
  var i;
  var newStepValues = [];
  newStepValues.push(stepValues[0]);
  for (i = 1; i < timeLen; i++) {
    slope = (stepValues[i] - newStepValues[i - 1]) / timeStep;
    absSlope = Math.abs(slope);
    if (absSlope > slewRate) {
      if (slope < 0) {
        sign = -1;
      } else {
        sign = 1;
      }
      newVal = newStepValues[i - 1] + slewRate * timeStep * sign;
      newStepValues.push(newVal);
    } else {
      newStepValues.push(stepValues[i]);
    }
  }
  return newStepValues;
}

//this function adds in the effect of slew rate for the TIA stage.   It deletes all points exceeding slew rate and replaces them with slew rate limited values. 
//It then time shifts the remaining points
function slewRateEffect_TIA(timeAxis, stepValues, slewRate) {
  var slope;
  var timeLen = timeAxis.length;
  var timeStep = timeAxis[1] - timeAxis[0];
  var newStepValues = [];
  var slewRateExceededArray = [];
  var i, j;

  //stop when we go over steady state value or if our slope falls under the slew rate rate (after first exceeding it)
  var slewRateExceeded = false;
  for (i = 0; i < timeLen; i++) {
    slope = Math.abs((stepValues[i + 1] - stepValues[i]) / timeStep);
    if (slope > slewRate) {
      slewRateExceededArray.push(true);
      slewRateExceeded = true;
    } else slewRateExceededArray.push(false);
  }

  //if no slew rate limiting, just return original waveform 
  if (!slewRateExceeded) {
    return stepValues;
  }

  //first segment: not slew limited.   Use original values;
  for (j = 0, i = 0; !slewRateExceededArray[i] && i < timeLen; j++, i++) {
    newStepValues[j] = stepValues[i];
  }

  //second segment: slew limited.   Make new slew limited values
  let startValue = stepValues[i];
  i = getIndexWhereSlewRateNoLongerLimited(slewRateExceededArray, timeLen, i);
  let stopValue = stepValues[i];
  j = addSlewRateLimitedValuesToNewStepValues(startValue, stopValue, newStepValues, timeStep, timeLen, j, slewRate);

  //third segment: not slew limited.  Reuse old values, but have to time shift and linearly interpolate
  for (; !slewRateExceededArray[i] && i < timeLen && j < timeLen; i++, j++) {
    newStepValues[j] = stepValues[i];
  }

  //fourth segment: slew limited.  Make new slew limited values
  startValue = stepValues[i];
  i = getIndexWhereSlewRateNoLongerLimited(slewRateExceededArray, timeLen, i);
  stopValue = stepValues[i];
  j = addSlewRateLimitedValuesToNewStepValues(startValue, stopValue, newStepValues, timeStep, timeLen, j, slewRate);

  //fifth segment.  The rest.   Assuming waveform now attenuated enough that no more slew rate limiting
  for (; !slewRateExceededArray[i] && i < timeLen && j < timeLen; i++, j++) {
    newStepValues[j] = stepValues[i];
  }
  return newStepValues;
}

//step through the old values above slew rate, so we can determine where slew rate limiting stops in old step array
function getIndexWhereSlewRateNoLongerLimited(slewRateExceededArray, timeLen, i) {
  while (slewRateExceededArray[i] && i < timeLen) {
    i++;
  }
  return i;
}

//This function adds slew rate limited values to our new stepValues in the slew rate limited segment
//It returns the spot where slew rate limiting ends in the newStepValues array
function addSlewRateLimitedValuesToNewStepValues(startValue, stopValue, newStepValues, timeStep, timeLen, j, slewRate) {
  //now create new step values by traveling on the slew rate slope starting from start value
  for (let k = 0; j < timeLen; j++, k++) {
    newStepValues[j] = startValue + slewRate * k * timeStep;
    if (newStepValues[j] > stopValue) {
      break;
    }
  }
  return j;
}

// function linearInterpolate(x3, x1, x2, y1, y2) {
//     var y3 = y1 + (((x3 - x1) * (y2 - y1)) / (x2 - x1));

//     return y3;
// }

function createTimeAxis(fCutOff) {
  var maxXaxis,
    stepSize,
    pointsInStepResponse,
    timeAxis = new Array();
  maxXaxis = Common.calculateMinPulseWidthSpeed(fCutOff);

  /*pointsInStepResponse sets the number of points in the graph  It is a compromise between speed and accuracy.   
  jqplot in takes about 300 ms to plot 512 points in firefox in Jan 2013.  However smaller numbers of points start 
  to show choppiness in plots with lots of ripple like bandpass*/

  pointsInStepResponse = 256;
  stepSize = maxXaxis / pointsInStepResponse;
  for (var k = 0; k < pointsInStepResponse; k++) {
    timeAxis[k] = k * stepSize;
  }
  return timeAxis;
}

//Create a set of stages that approximate the performance of the circuit.   Since we only know know to calculate step response for 1st and 2nd order stages, this information
//must be put in that form.
function createStagesforStepResponse(inputValues, opAmpDB, stagesObject) {
  var plottingStages = [];
  var realStage1 = stagesObject.stage1;
  var realStage2 = stagesObject.stage2;

  //first stage:  transimpedance circuit assuming ideal integrator op amp
  //get Q for first stage.   By using this Q, rather than the original user's request, it will incorporate peaking effects from the gbw*2 pole of the op amp.
  var results = GraphCalculations.calculateNaturalFrequencyAndQ(stagesObject, _photodiodeConstants.default.pdStages.oneStage);
  plottingStages.push({
    Stage: "2",
    StageQ: results.q,
    StageFp: results.fn,
    StageFz: 1,
    Gain: realStage1.rf * inputValues.peakCurrent,
    StageId: 1,
    stageType: _photodiodeConstants.default.filterType.lowPass,
    slewRate: 1e6 * realStage1.opAmp.slewRate
  });

  //this stage incorporates secondary pole(s) from op amp
  if (realStage1.opAmp.feedbackMethod === "Current" && realStage1.opAmp.cfb) {
    //current feedback second stage: incorporate two secondary poles at 2.414214 * minRf frequency
    var freq135 = realStage1.opAmp.cfb.zbw / realStage1.opAmp.cfb.minRf;
    var freqDualPole = freq135 * 2.414214;
    plottingStages.push({
      Stage: "2",
      StageQ: 0.707,
      StageFp: freqDualPole,
      StageFz: 1,
      Gain: 1,
      StageId: 1,
      stageType: _photodiodeConstants.default.filterType.lowPass,
      slewRate: 1e60 //make slew rate so big it doesn't matter
    });
  } else {
    //voltage feedback second stage: incorporate second op amp pole at gbw*2
    plottingStages.push({
      Stage: "1",
      StageQ: 0.707,
      StageFp: realStage1.opAmp.gbw * 2,
      StageFz: 1,
      Gain: 1,
      StageId: 1,
      stageType: _photodiodeConstants.default.filterType.lowPass,
      slewRate: 1e60 //make slew rate so big it doesn't matter
    });
  }
  if (inputValues.stages === _photodiodeConstants.default.pdStages.twoStage) {
    // third stage:  effect of cfilter
    var stage3fp;
    if (inputValues.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.negative) {
      stage3fp = 1 / (2 * Math.PI * realStage2.cfilter * realStage2.rfilter);
    } else {
      stage3fp = 1 / (2 * Math.PI * realStage2.cfilter * realStage2.rf);
    }
    plottingStages.push({
      Stage: "1",
      StageQ: 0.707,
      StageFp: stage3fp,
      StageFz: 1,
      Gain: 1,
      StageId: 1,
      stageType: _photodiodeConstants.default.filterType.lowPass,
      slewRate: 1e60 //make so big it doesn't matter
    });
    let stage4fp;
    // fourth stage: 2nd stage frequency response assuming ideal integrator op amp
    if (realStage2.opAmp.feedbackMethod === "Current" && realStage2.opAmp.cfb) {
      var rpar = realStage2.rg * realStage2.opAmp.cfb.rIn / (realStage2.rg + realStage2.opAmp.cfb.rIn);
      var beta_current = rpar / (realStage2.rf + rpar) / realStage2.opAmp.cfb.rIn;
      stage4fp = realStage2.opAmp.cfb.zbw * beta_current;
    } else {
      stage4fp = realStage2.opAmp.gbw / (1 + realStage2.rf / realStage2.rg);
    }
    let stage4Gain;
    if (inputValues.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.negative) {
      stage4Gain = 1 + realStage2.rf / realStage2.rg;
    } else {
      stage4Gain = realStage2.rf / realStage2.rg;
    }
    plottingStages.push({
      Stage: "1",
      StageQ: 0.707,
      StageFp: stage4fp,
      StageFz: 1,
      Gain: stage4Gain,
      StageId: 1,
      stageType: _photodiodeConstants.default.filterType.lowPass,
      slewRate: 1e6 * realStage2.opAmp.slewRate
    });
  }
  return plottingStages;
}

//See step response documentation in Filter Wizard confluence for where all this comes from.  
function stepResponseSetup(stage) {
  var a,
    b,
    c,
    w0,
    Q,
    pi = Math.PI;
  if (stage.Stage == "0") {
    w0 = 0;
    Q = 0;
    if (stage.stageType == "gain") {
      a = stage.Gain;
      b = 0;
      c = 0;
    } else {
      console.log("should never happen");
    }
  }
  if (stage.Stage == "1") {
    w0 = stage.StageFp * 2 * pi; // stageFp for butterworth and chebyshev

    Q = 0;
    c = 0;
    if (stage.stageType == _photodiodeConstants.default.filterType.lowPass) {
      a = stage.Gain;
      b = stage.Gain;
    } else if (stage.stageType == _photodiodeConstants.default.filterType.highPass) {
      a = 0;
      b = -1 * stage.Gain;
    }
  }
  if (stage.Stage == "2") {
    w0 = stage.StageFp * 2 * pi; // stageFp for butterworth and chebyshev

    Q = stage.StageQ;
    if (stage.stageType == _photodiodeConstants.default.filterType.lowPass) {
      a = 0;
      b = 0;
      c = stage.Gain * Math.pow(w0, 2);
    }
    if (stage.stageType == _photodiodeConstants.default.filterType.highPass) {
      a = stage.Gain;
      b = 0;
      c = 0;
    }
    if (stage.stageType == _photodiodeConstants.default.filterType.bandPass) {
      a = 0;
      b = stage.Gain * w0 / Q;
      c = 0;
    }
    if (stage.stageType == "notch") {
      a = stage.Gain;
      b = 0;
      c = stage.Gain * Math.pow(w0, 2);
    }
    if (stage.stageType == "gain") {
      console.log("should never happen");
    }
  }
  return [a, b, c, w0, Q]; //return a,b,c,w0,Q
}

//See step response documentation in Filter Wizard confluence for where all this comes from.  Particularly the "step response calculations from Art.pdf".
function stepResponseIdeal(timePoint, stepResSetup, stage) {
  var answer;
  var a = stepResSetup[0];
  var b = stepResSetup[1];
  var c = stepResSetup[2];
  var w0 = stepResSetup[3];
  var Q = stepResSetup[4];
  var X;
  var Y;
  var W;
  var Z;
  if (stage.Stage == "0" || stage.Stage == "1") {
    var tw0 = -1 * timePoint * w0;
    answer = a - b * Math.exp(tw0);
  }
  if (stage.Stage == "2") {
    X = -c - a * Math.pow(w0, 2) + 2 * b * w0 * Q; //X=-c-a*wo**2+2*b*wo*Q;
    Y = -Math.pow(w0, 2) * (-1 + 4 * Math.pow(Q, 2)); //Y=-wo**2*(-1 + 4*Q**2);
    W = a * Math.pow(w0, 2) - c; //W=a*wo**2-c;
    Z = Math.exp(-timePoint * w0 / 2 / Q); //Z=exp(-t*wo/2/Q);

    if (Y > 0) {
      var sqrtY = Math.sqrt(Y); //sqrt(Y)
      var tYQ = timePoint * sqrtY / 2 / Q; //t*sqrt(Y)/2/Q

      var sinhY = Math.sinh(tYQ); //sinh(t*sqrt(Y)/2/Q)
      var coshY = Math.cosh(tYQ); //cosh(t*sqrt(Y)/2/Q)
      //There are some cases where Z goes to 0 and sinhY and coshY go to infinity.
      //As long as we're not recommending absolutely horrible circuits that are completely unstable (if we are, we have more serious problems),
      //Z should go to 0 faster than sinhY and coshy go to infinity, so result should be 0. Trouble is, computer doesn't know this.
      //It generates NaN when 0 * infinity, which kills our plot.  So we add this check. 
      //An even safer method would be to decompose the sinhY and coshY functions into exponentials, multiply by Z using the exponent terms 
      //(i.e. add the exponent terms), and then take the exponential.  This would work for unstable circuits too.  But the math is hard enough
      // to follow already!  So we use this check instead.
      if ((X * sinhY === Infinity || W * coshY === Infinity || X * sinhY === -Infinity || W * coshY === -Infinity) && Z === 0) {
        sinhY = 1;
        coshY = 1;
      }
      answer = X * sinhY * Z / sqrtY / w0 + (c + W * coshY * Z) / Math.pow(w0, 2);
    }
    if (Y < 0) {
      var sqrtNegY = Math.sqrt(-Y); //sqrt(-Y)

      answer = X * Math.sin(timePoint * sqrtNegY / 2 / Q) * Z / sqrtNegY / w0 + (c + W * Math.cos(timePoint * sqrtNegY / 2 / Q) * Z) / Math.pow(w0, 2);
    }
    if (Y == 0) {
      var w02 = Math.pow(w0, 2); //w0**2
      var w03 = Math.pow(w0, 3); //w0**3
      var exptw0 = Math.exp(timePoint * w0); // exp(t*wo)

      answer = -(c - c * exptw0 - a * w02 + a * timePoint * w03 - b * timePoint * w02 + c * timePoint * w0) / (w02 * exptw0);
    }
  }
  return answer;
}
function impulseResponse(timeAxis, stage) {
  var t;
  var impulseArray = [];
  var firstPoint;
  var secondPoint;
  var timeLen = timeAxis.length;
  var StepResSet = stepResponseSetup(stage);
  if (stage.stageType == _photodiodeConstants.default.filterType.highPass || stage.stageType == _photodiodeConstants.default.filterType.gain) {
    impulseArray[0] = stage.Gain;
  } else {
    impulseArray[0] = 0;
  }
  firstPoint = stepResponseIdeal(timeAxis[0], StepResSet, stage); // for t=0

  //starting the loop with second point
  for (t = 1; t < timeLen; t++) {
    secondPoint = stepResponseIdeal(timeAxis[t], StepResSet, stage);
    impulseArray[t] = secondPoint - firstPoint;
    firstPoint = secondPoint;
  }
  return impulseArray;
}

// function adjustStepResponse(stages, stepResponseArray, inputValues) {
//     var totalGain = 1;

//     // Multiple gain from all stages calculated in step 2.
//     for (let i = 0, len = stages.length; i < len; i++) {
//         totalGain = totalGain * stages[i].Gain;
//     }

//     // Divide step response by this total gain.
//     // Then multiply step response by the output voltage requested by the user.
//     for (let j = 0, len = stepResponseArray.length; j < len; j++) {
//         stepResponseArray[j] = (stepResponseArray[j] / totalGain) * inputValues.peakVoltage;
//     }

//     // if (user has selected a one stage design) && (photodiode polarity is positive)
//     // multiply step response points by -1
//     if (inputValues.stages == 1 && inputValues.biasPreference == PhotodiodeConstants.biasPreferenceOptions.positive) {
//         for (var k = 0, len = stepResponseArray.length; k < len; k++) {
//             stepResponseArray[k] = stepResponseArray[k] * -1;
//         }
//     }

//     return stepResponseArray;
// }

//This function inverts the step response 
// function invertStepResponse(stepResponseArray, inputValues) {
//     if (inputValues.stages == 1 && inputValues.biasPreference == PhotodiodeConstants.biasPreferenceOptions.positive) {
//         for (var k = 0, len = stepResponseArray.length; k < len; k++) {
//             stepResponseArray[k] = stepResponseArray[k] * -1;
//         }
//     }

//     return stepResponseArray;
// }

//This function not ready for prime time. When calculating the downward slope, it assumes that everything has
//settled to steady state, which is not the case. Somehow modifications need to be made to account for the charged
//state of the existing components.
// function convertToPulseResponse(stepResponseArray, inputValues, timeAxis) {
//     //get step response as if we were directly converting frequency response graph (complete with massive gain)
//     var posArray = stepResponseArray;
//     var negArray = [];
//     var pulseArray = [];
//     var extraTime = [];
//     var lastValue = stepResponseArray[stepResponseArray.length - 1];
//     var onePoint;

//     if ((inputValues.stages === '1') || (inputValues.biasPreference === 'negative')) {
//         //show positive pulse first and have everything be above zero
//         for (let i = 0; i < posArray.length; i++) {
//             //scale in case last value hasn't settled yet
//             onePoint = lastValue / inputValues.peakVoltage * posArray[i];
//             negArray.push(lastValue - onePoint);
//         }
//         pulseArray = posArray.concat(negArray);
//     }
//     else {
//         //show negative pulse first and have everything below zero
//         for (let i = 0; i < posArray.length; i++) {
//             negArray.push(-posArray[i]);
//             //scale in case last value hasn't settled yet
//             onePoint = lastValue / inputValues.peakVoltage * posArray[i];
//             posArray[i] = posArray[i] - lastValue;
//         }
//         pulseArray = negArray.concat(posArray);
//     }

//     //now double the timeAxis
//     let timeInterval = timeAxis[1] - timeAxis[0];
//     let origLength = timeAxis.length;
//     for (let i = 0; i < origLength; i++) {
//         extraTime.push((origLength + i) * timeInterval);
//     }
//     var newTimeAxis = timeAxis.concat(extraTime);

//     return [newTimeAxis, pulseArray];
// }

//This function currently not used, but kept in here in case we want to use it in the future.
//It seems like we need a 10,000 point computation to get a reasonably good step response result.
//However it takes about the following amount of time to do this:
//createComplexClosedLoopGainArray: 200 ms
//inverseFourier: 800 ms
//This might be able to optimized by doing the following:
//- interpolate the higher complexClosedLoopGain values rather than calculating them outright
//- use FFT techniques (i.e. Cooley Tukey algorithm) in inverseFourier function
// static stepFromFourier(stagesObject, inputValues) {
//     var freqStep = inputValues.speed / 100;
//     var freqStop = inputValues.speed * 100;
//     var frequency;

//     var frequencyArray = [1e-6];  //Start with frequency very close to DC, but not zero
//     for (frequency = freqStep; frequency < freqStop; frequency += freqStep) {
//         frequencyArray.push(frequency);
//     }

//     console.time('complexClosedLoopGainArray');
//     var complexClosedLoopGainArray = this.createComplexClosedLoopGainArray(frequencyArray, stagesObject, inputValues, true);
//     console.timeEnd('complexClosedLoopGainArray');
//     console.time('inverseFourier');
//     var stepResponseResults = this.inverseFourier(complexClosedLoopGainArray, freqStep, 400, complexClosedLoopGainArray[0].magnitude());
//     console.timeEnd('inverseFourier');

//     return stepResponseResults;
// }